export default __webpack_public_path__ + "static/media/sundarp.c8bba9c8.jpeg";